export interface UserLoginRequest {
    email: string;
    password: string;
}

/**
 * This interface represents the request payload for user refresh token API.
 * Infact it takes the refreshToken from the user local store and verify if it is a valid
 * token to provide a new accessToken and idToken.
 */
export interface RefreshTokenRequest {
    refreshToken: string;
}

export interface RefreshTokenResponse {
    accessToken: string,
    idToken: string,
}


export interface UserChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
}

export interface UserCreationRequest {
    email: string;
    password: string;
    role: string;
    userName:  string;
}

export interface UserSearchFilter {
    email?: string;
    role?: string;
    confirmed?: boolean;
    excludeClients?: boolean;
}

export interface UserSearchResponse {
    count: number;
    data: UserData[];
}

export interface UserData {
    id: number;
    email: string;
    role: string;
    userName:  string;
    confirmed: boolean;
}

export interface User {
    accessToken: string,
    idToken: string,
    refreshToken: string,
    userAttributes: UserAttributes;
}

export interface UserAttributes {
    email: string;
    email_verified: boolean;
    "custom:user_name": string;
    "custom:role": Role;
    sub: string;
}

export enum Role {
    SUPER_ADMIN = "SUPER_ADMIN",
    TRAVEL_DESIGNER = "TRAVEL_DESIGNER",
    ACCOUNTANT = "ACCOUNTANT",
    CLIENT = "CLIENT"
}

export const RoleTranslationMap: Record<Role, string> = {
    [Role.SUPER_ADMIN]: 'Super Admin',
    [Role.TRAVEL_DESIGNER]: 'Travel Designer',
    [Role.ACCOUNTANT]: 'Accountant',
    [Role.CLIENT]: 'Client',
};